module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/car-c65f0881e87fb3e843ea8f412b96b19e.png";